import React from "react";
import _ from "lodash";
import "./Pagination.css"

const ProjectPagination = ({
  itemsCount,
  pageSize,
  currentPage,
  onPageChange,
}) => {
  const pagesCount = Math.ceil(itemsCount / pageSize);
  if (pagesCount === 1) return null;
  const pages = _.range(1, pagesCount + 1);
  
  return (
    <nav style={{ zIndex: 0 }}>
      <ul className="pagination">
        {pages.map((page) => (
          <li
            key={page}
            className={page === currentPage ?
                //is the active page the first page
                page === 1 ? ("page_button_active_first"):(
                    //is the active page the last page?
                    page === pagesCount ? (
                        "page_button_active_last"
                    ):(
                        "page_button_active"
                    )
                )
                :
                //is the inactive button the first?
                page === 1 ? ("page_button_first"):(
                    //is the inactive button page the last page?
                    page === pagesCount ? (
                        "page_button_last"
                    ):(
                        "page_button"
                    )
                )}
          >
            <div onClick={() => onPageChange(page)}>
              {page}
            </div>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default ProjectPagination;
